export enum ProjectsEnum {
  CREATED = "CRAETED",
  JOINED = "JOINED",
}
